<template>
    <!-- 手动审核：任务结算前审核按钮置灰，任务结算后才可审核，审核通过后奖励直接发放。自动审核：审核按钮显示：自动审核，不可点击。任务结算后满足任务要求，奖励自动发放 -->
    <!-- 注意：cyclicalChange奖励发放周期方法 @visible-change方法 与super端调用不同接口 -->
    <!-- 司机-司机任务-添加任务 -->
    <el-dialog title="司机任务" :visible.sync="show" :before-close="closeDialog" width="900px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form label-width="180px" ref="form" :model="submit_data" style="height: 700px; overflow-y: auto">
                    <div>
                        <div>
                            <!-- 司机类型 -->
                            <el-form-item label="司机类型:">
                                <el-select
                                    v-model="submit_data.driver_type"
                                    placeholder="请选择"
                                    style="width: 220px"
                                    :disabled="btnType == 'edit'"
                                >
                                    <el-option label="全部" value="3"></el-option>
                                    <el-option label="包月" value="1"></el-option>
                                    <el-option label="包天" value="0"></el-option>
                                    <el-option label="按单" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="task-head">
                            <!-- 标题前小方块 -->
                            <div class="title-square"></div>
                            <!-- 标题 -->
                            <span style="display: inline-block">任务名称:</span>
                        </div>
                        <el-form-item label="任务名称:">
                            <el-input
                                :disabled="btnType == 'edit'"
                                v-model="submit_data.task_name"
                                :placeholder="submit_rules.task_name.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                        <div class="task-head">
                            <!-- 标题前小方块 -->
                            <div class="title-square"></div>
                            <!-- 标题 -->
                            <span style="display: inline-block">任务时间配置:</span>
                        </div>

                        <el-form-item label="任务开启时间:">
                            <el-date-picker
                                :disabled="btnType == 'edit'"
                                value-format="yyyy-MM-dd"
                                v-model="submit_data.start_date"
                                type="date"
                                :placeholder="submit_rules.start_date.placeholder"
                            >
                            </el-date-picker>
                            至
                            <el-date-picker
                                :disabled="btnType == 'edit'"
                                value-format="yyyy-MM-dd"
                                v-model="submit_data.end_date"
                                type="date"
                                :placeholder="submit_rules.end_date.placeholder"
                            >
                            </el-date-picker>
                        </el-form-item>

                        <div class="task-head">
                            <!-- 标题前小方块 -->
                            <div class="title-square"></div>
                            <!-- 标题 -->
                            <span style="display: inline-block">任务达成条件&奖励配置:</span>
                        </div>

                        <div
                            v-for="(item, index) in condition_loop"
                            :key="index"
                            style="width: 760px; border: 1px solid #ccc; border-radius: 10px; margin: 10px 0; padding-top: 10px"
                        >
                            <!-- 如果选择司机招募，其他的任务类型不可以选择，也不可以添加时间段，是否审核只能选择手动审核，自动的置灰
                            如果选择其他任务类型，需要先取消司机招募的勾选，也就是司机招募与其他任务类型互斥 -->
                            <el-form-item label="任务类型:">
                                <el-checkbox-group v-model="checkedType" @change="handleRewardType(index)" :disabled="btnType == 'edit'">
                                    <el-checkbox :label="'condition_time' + index" key="condition_time"
                                        >在线时长

                                        <el-input
                                            :disabled="btnType == 'edit'"
                                            v-if="condition_time_isShow[index]"
                                            v-model="condition_loop[index].condition_time"
                                            placeholder="小时"
                                            style="width: 60px; margin-left: 5px"
                                        >
                                        </el-input>
                                    </el-checkbox>
                                    <el-checkbox :label="'condition_order' + index" key="condition_order"
                                        >完成单数

                                        <el-input
                                            :disabled="btnType == 'edit'"
                                            v-if="condition_order_isShow[index]"
                                            v-model="condition_loop[index].condition_order"
                                            placeholder="完成单数"
                                            style="width: 60px; margin-left: 5px"
                                        >
                                        </el-input
                                    ></el-checkbox>
                                    <el-checkbox :label="'condition_online_pay' + index" key="condition_online_pay"
                                        >在线支付

                                        <el-input
                                            :disabled="btnType == 'edit'"
                                            v-if="condition_online_pay_isShow[index]"
                                            v-model="condition_loop[index].condition_online_pay"
                                            placeholder="单"
                                            style="width: 60px; margin-left: 5px"
                                        >
                                        </el-input>
                                    </el-checkbox>
                                    <!-- condition_recruitment0 -->
                                    <!-- condition_recruitment1 -->
                                    <!-- condition_recruitment2 -->
                                    <!-- 招募司机，司机在时间范围内上传图片的数量，注意：勾选司机招募后下方加号按钮置灰且时间段为00：00-00：00 -->
                                    <el-checkbox :label="'condition_recruitment' + index" key="condition_recruitment"
                                        >司机招募

                                        <el-input
                                            :disabled="btnType == 'edit'"
                                            v-if="condition_recruitment_isShow[index]"
                                            v-model="condition_loop[index].condition_recruitment"
                                            style="width: 60px; margin-left: 5px"
                                        >
                                        </el-input>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="招募司机：司机在时间范围内上传图片的数量，司机招募与“在线时长”“完成单数”“在线支付”互斥"
                                            placement="right"
                                        >
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>

                            <el-form-item label="时间段配置:">
                                <div style="display: flex; align-items: center">
                                    <el-time-select
                                        :disabled="btnType == 'edit' || is_recruitment"
                                        placeholder="起始时间"
                                        v-model="condition_loop[index].start_time"
                                        :picker-options="{
                                            start: '00:00',
                                            step: '00:30',
                                            end: '24:00'
                                        }"
                                        style="width: 200px; margin-right: 10px"
                                    >
                                    </el-time-select>

                                    <!-- <span>{{ textIsShow }}</span> -->
                                    <span
                                        style="margin-right: 10px"
                                        v-if="
                                            condition_loop[index].start_time !== '' &&
                                            condition_loop[index].end_time !== '' &&
                                            condition_loop[index].start_time > condition_loop[index].end_time
                                        "
                                        >至次日</span
                                    >
                                    <el-time-select
                                        :disabled="btnType == 'edit' || is_recruitment"
                                        placeholder="结束时间"
                                        v-model="condition_loop[index].end_time"
                                        :picker-options="{
                                            start: '00:00',
                                            step: '00:30',
                                            end: '24:00'
                                        }"
                                        style="width: 200px"
                                    >
                                    </el-time-select>
                                    <el-tooltip
                                        class="item"
                                        effect="dark"
                                        content="时间段若设置为00:00至00:00为全天"
                                        placement="top"
                                        style="margin-left: 5px"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                    <div style="margin-left: 15px">
                                        <!-- 勾选司机招募，则不显示添加按钮，且时间为00：00-00：00 -->
                                        <el-button
                                            v-if="!is_recruitment"
                                            :disabled="btnType == 'edit'"
                                            @click="addBtn"
                                            type="success"
                                            icon="el-icon-plus"
                                        ></el-button>
                                        <!-- 只剩下一项的时候不显示删除按钮 -->
                                        <el-button
                                            :disabled="btnType == 'edit'"
                                            v-if="index != '0'"
                                            @click="delData(index)"
                                            type="danger"
                                            icon="el-icon-close"
                                        ></el-button>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>

                        <el-form-item label="奖励发放周期:">
                            <el-select
                                :disabled="btnType == 'edit'"
                                v-model="submit_data.reward_cyclical"
                                @visible-change="cyclicalChange"
                                placeholder="请选择奖励发放周期"
                                style="width: 150px; margin-right: 20px"
                                clearable
                            >
                                <el-option :label="item.v" :value="item.k" v-for="(item, index) in reward_cyclical" :key="index">
                                </el-option>
                            </el-select>
                            <span class="desc">注：任务结算都是每日凌晨结算，根据发放周期次日或次月下发奖励</span>
                        </el-form-item>
                        <!-- 如果勾选司机招募，则审核方式为手动审核，且禁用选择 -->
                        <el-form-item label="审核方式:">
                            <el-radio-group
                                v-model="submit_data.is_reviewed"
                                :disabled="is_recruitment || btnType == 'edit'"
                                style="margin-right: 5px"
                            >
                                <el-radio-button label="0">自动审核</el-radio-button>
                                <el-radio-button label="1">手动审核 </el-radio-button>
                            </el-radio-group>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="如果任务类型包含司机招募，则审核方式为手动审核，且审核方式禁止重新选择"
                                placement="right"
                            >
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="奖励有效期:">
                            <el-input
                                :disabled="btnType == 'edit'"
                                v-model="submit_data.send_cyclical"
                                :placeholder="submit_rules.send_cyclical.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>

                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="表现分的有效期，优享券有效期取配置参数，现金没有有效期"
                                placement="right"
                            >
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>

                        <el-form-item label="奖励类型:">
                            <el-checkbox-group v-model="checkedRewards" @change="handleReward" :disabled="btnType == 'edit'">
                                <el-checkbox label="reward_amount" key="reward_amount"
                                    >现金(元)

                                    <el-input
                                        :disabled="btnType == 'edit'"
                                        v-if="reward_amount_isShow"
                                        v-model="submit_data.reward_amount"
                                        placeholder="现金"
                                        style="width: 60px; margin-right: 5px"
                                    >
                                    </el-input>
                                </el-checkbox>
                                <el-checkbox label="reward_monitor" key="reward_monitor"
                                    >表现分<el-input
                                        :disabled="btnType == 'edit'"
                                        v-if="reward_monitor_isShow"
                                        v-model="submit_data.reward_monitor"
                                        placeholder="表现分"
                                        style="width: 60px; margin-right: 5px"
                                    >
                                    </el-input
                                ></el-checkbox>
                                <el-checkbox label="reward_priority" key="reward_priority">优享券 </el-checkbox>
                                <el-select
                                    :disabled="btnType == 'edit'"
                                    v-if="reward_priority_isShow"
                                    v-model="submit_data.reward_priority"
                                    placeholder="请选择优享券"
                                    style="width: 160px; margin-right: 20px"
                                    clearable
                                >
                                    <el-option
                                        :label="item.name"
                                        :value="item.priority_mode_code"
                                        v-for="(item, index) in reward_priority"
                                        :key="index"
                                    >
                                    </el-option>
                                </el-select>
                                <el-button
                                    v-if="reward_priority_isShow"
                                    class="el-icon-minus"
                                    style="padding: 5px"
                                    @click="rewardBtn('-')"
                                ></el-button>
                                <el-input
                                    :disabled="btnType == 'edit'"
                                    v-if="reward_priority_isShow"
                                    v-model="submit_data.reward_priority_num"
                                    placeholder="数量"
                                    style="width: 70px"
                                >
                                </el-input>
                                <el-button
                                    v-if="reward_priority_isShow"
                                    class="el-icon-plus"
                                    style="padding: 5px"
                                    @click="rewardBtn('+')"
                                ></el-button>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="任务次数:">
                            <el-input
                                :disabled="btnType == 'edit'"
                                v-model="submit_data.top_num"
                                :placeholder="submit_rules.top_num.placeholder"
                                style="width: 220px; margin-right: 5px"
                            >
                            </el-input>
                            <span class="desc">在奖励发放周期内最多完成次数</span>
                        </el-form-item>
                        <!-- 勾选完成单数，显示自定义配置 -->

                        <div v-if="diyIsShow">
                            <div class="task-head">
                                <!-- 标题前小方块 勾选完成单数，显示自定义配置-->
                                <div class="title-square"></div>
                                <!-- 标题 -->
                                <span style="display: inline-block">自定义配置:</span>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="默认全部支持，请根据自己城市实际情况选用配置项，每项配置至少选择一个"
                                    placement="right"
                                >
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </div>
                            <el-form-item label="任务支持的订单来源:" label-width="180px">
                                <el-checkbox-group v-model="order_source" size="mini" @change="diyConfig" :disabled="btnType == 'edit'">
                                    <el-checkbox
                                        v-for="(item, index) in platform_select_array"
                                        :label="item.val"
                                        :key="index"
                                        border
                                        style="margin: 5px"
                                    >
                                        {{ item.alias }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="任务支持的支付方式:" label-width="180px">
                                <el-checkbox-group v-model="pay_channel" size="mini" @change="diyConfig" :disabled="btnType == 'edit'">
                                    <el-checkbox
                                        v-for="(item, index) in pay_channel_array"
                                        :label="item.val"
                                        :key="index"
                                        border
                                        style="margin: 5px"
                                    >
                                        {{ item.alias }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="任务支持的订单模式:" label-width="180px">
                                <el-checkbox-group v-model="order_modes" size="mini" @change="diyConfig" :disabled="btnType == 'edit'">
                                    <el-checkbox
                                        v-for="(item, index) in options_mode_code"
                                        :label="item.code"
                                        :key="index"
                                        border
                                        style="margin: 5px"
                                    >
                                        {{ item.name }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center; padding-top: 10px">
                    <el-button type="primary" @click="onSubmitDig" v-if="btnType == 'add'">保存</el-button>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-dialog>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: {},
        btnType: '' // 区分添加和编辑
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            if (_this.btnType == 'add') {
                // 添加页面
                _this.loading = false;
            } else {
                // 查看页面
                _this.details(); // 获取详情
            }
            _this.orderModeList();
            _this.getPayChannel();
            _this.getPlatform();
            _this.priorityLists();
        }
    },

    data() {
        return {
            show: false,
            loading: true,
            is_recruitment: false, // 自动审核 和 手动审核是否禁用
            diyIsShow: false, // 勾选完成单数，显示自定义配置
            reward_amount_isShow: false, // 奖励类型现金是否显示
            reward_monitor_isShow: false, // 奖励类型表现分是否显示
            reward_priority_isShow: false, // 奖励类型优享券是否显示
            condition_time_isShow: [false], // 在线时长后的输入框是否显示
            condition_online_pay_isShow: [false], // 在线支付后的输入框是否显示
            condition_order_isShow: [false], // 完成单数后的输入框是否显示
            condition_recruitment_isShow: [false], // 司机招募后的输入框是否显示
            condition_loop: [
                {
                    condition_time: '', // 在线时长
                    condition_order: '', // 完成单数
                    condition_online_pay: '', // 在线支付
                    condition_recruitment: '', // 司机招募
                    start_time: '', // 起始时间
                    end_time: '' // 结束时间
                }
            ],

            checkedRewards: [], // 奖励类型v-model绑定值
            checkedType: [], // 任务类型v-model

            reward_cyclical: [], // 奖励发放周期
            reward_priority: [], // 优享券数组

            pay_channel: [], //支付方式 <el-checkbox-group v-model绑定值
            order_source: [], //订单来源 <el-checkbox-group v-model绑定值
            order_modes: [], //订单模式复选框v-model绑定值 <el-checkbox-group v-model绑定值
            platform_select_array: [], //任务支持的订单来源
            pay_channel_array: [], // 任务支持的支付方式
            options_mode_code: [], // 任务支持的订单模式
            // 优享券查询条件
            search_data_reward: {
                page: 1,
                limit: 10
            },
            // 表单数据
            submit_data: {
                driver_type: '', // 司机类型
                task_name: '', // 任务名称
                start_date: '', // 任务开启日期
                end_date: '', // 任务结束日期
                reward_cyclical: '', // 奖励发放周期
                is_reviewed: '0', // 审核方式
                send_cyclical: '', // 奖励有效期
                reward_amount: '', // 现金
                reward_monitor: '', // 表现分
                reward_priority: '', // 优享券
                reward_priority_num: '', // 优享券数量
                top_num: '', // 任务次数
                order_source: '', // 订单来源
                pay_channel: '', // 支付方式
                order_modes: '', // 订单模式
                condition_loop: '' // 循环
            },

            // 订单模式查询条件
            mode_options_data: {
                page: 1,
                limit: 10,
                status: '1'
            },

            search_data: {
                page: 1,
                limit: 10
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },

            submit_rules: {
                driver_type: {
                    placeholder: '司机类型',
                    rules: {
                        required: true,
                        message: '司机类型不能为空',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                task_name: {
                    placeholder: '任务名称',
                    rules: {
                        required: true,
                        message: '任务名称需大于3个字',
                        regulation: 'gt_str',
                        rulesData: 2
                    }
                },
                start_date: {
                    placeholder: '任务开启日期',
                    rules: {
                        required: true,
                        message: '任务开启日期',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                end_date: {
                    placeholder: '任务结束日期',
                    rules: {
                        required: true,
                        message: '任务结束日期',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },

                reward_cyclical: {
                    placeholder: '奖励发放周期',
                    rules: {
                        required: true,
                        message: '请选择奖励发放周期',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                is_reviewed: {
                    placeholder: '审核方式',
                    rules: {
                        required: true,
                        message: '请选择审核方式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                send_cyclical: {
                    placeholder: '奖励有效期',
                    rules: {
                        required: true,
                        message: '请选择奖励有效期',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                reward_amount: {
                    placeholder: '现金',
                    rules: {
                        required: false,
                        message: '现金为数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                reward_monitor: {
                    placeholder: '表现分',
                    rules: {
                        required: false,
                        message: '表现分为数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                reward_priority: {
                    placeholder: '优享券',
                    rules: {
                        required: false,
                        message: '优享券错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                reward_priority_num: {
                    placeholder: '优享券数量',
                    rules: {
                        required: false,
                        message: '优享券数量为数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                top_num: {
                    placeholder: '任务次数',
                    rules: {
                        required: true,
                        message: '任务次数为数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                order_source: {
                    placeholder: '订单来源',
                    rules: {
                        required: false,
                        message: '请选择订单来源',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                pay_channel: {
                    placeholder: '支付方式',
                    rules: {
                        required: false,
                        message: '请选择支付方式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                order_modes: {
                    placeholder: '订单模式',
                    rules: {
                        required: false,
                        message: '请选择订单模式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
                // condition_loop: {
                //     placeholder: '任务配置',
                //     rules: {
                //         required: false,
                //         message: '任务配置错误',
                //         regulation: 'gt_str',
                //         rulesData: 0
                //     }
                // }
                // condition_time: {
                //     placeholder: '在线时长',
                //     rules: {
                //         required: false,
                //         message: '在线时长为必填项',
                //         regulation: 'gt_str',
                //         rulesData: 0
                //     }
                // },
                // condition_order: {
                //     placeholder: '完成单数',
                //     rules: {
                //         required: false,
                //         message: '完成单数为必填项',
                //         regulation: 'gt_str',
                //         rulesData: 0
                //     }
                // },
                // condition_online_pay: {
                //     placeholder: '在线支付',
                //     rules: {
                //         required: false,
                //         message: '在线支付为必填项',
                //         regulation: 'gt_str',
                //         rulesData: 0
                //     }
                // },
                // condition_recruitment: {
                //     placeholder: '司机招募',
                //     rules: {
                //         required: false,
                //         message: '司机招募为必填项',
                //         regulation: 'gt_str',
                //         rulesData: 0
                //     }
                // },
                // start_time: {
                //     placeholder: '起始时间',
                //     rules: {
                //         required: false,
                //         message: '起始时间为必填项',
                //         regulation: 'gt_str',
                //         rulesData: 0
                //     }
                // },
                // end_time: {
                //     placeholder: '结束时间',
                //     rules: {
                //         required: false,
                //         message: '结束时间为必填项',
                //         regulation: 'gt_str',
                //         rulesData: 0
                //     }
                // }
            }
        };
    },
    created() {
        _this = this;
    },
    computed: {
        // 时间段配置至次日算法
        textIsShow() {
            if (_this.end_time != '' && _this.start_time != '' && _this.end_time != null && _this.start_time != null) {
                if (_this.end_time.slice(0, 2) <= _this.start_time.slice(0, 2)) {
                    return '至次日';
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    },
    methods: {
        // 详情接口
        details() {
            _this
                .$post('/task_new/details', {
                    driver_task_code: _this.data.driver_task_code
                })
                .then((res) => {
                    _this.submit_data.driver_type = res.data.driver_type; // 司机类型
                    _this.submit_data.task_name = res.data.task_name; // 任务名称
                    _this.submit_data.start_date = res.data.start_date; // 任务开启时间
                    _this.submit_data.end_date = res.data.end_date; //任务结束时间

                    if (Number(res.data.reward_amount > 0)) {
                        // 如果接口返回的现金>0，给现金赋值
                        _this.reward_amount_isShow = true;
                        _this.checkedRewards.push('reward_amount');
                        _this.submit_data.reward_amount = res.data.reward_amount;
                    }
                    if (Number(res.data.reward_monitor > 0)) {
                        // 如果接口返回的表现分>0，给表现分赋值
                        _this.reward_monitor_isShow = true;
                        _this.checkedRewards.push('reward_monitor');
                        _this.submit_data.reward_monitor = res.data.reward_monitor;
                    }
                    if (Number(res.data.reward_priority_num > 0)) {
                        // 如果接口返回的优享券>0，给优享券赋值
                        _this.reward_priority_isShow = true;
                        _this.checkedRewards.push('reward_priority');
                        _this.submit_data.reward_priority = res.data.reward_priority;
                        _this.submit_data.reward_priority_num = res.data.reward_priority_num;
                    }

                    if (res.data.condition_loop.length > 0) {
                        _this.condition_loop = res.data.condition_loop; // 循环
                        let condition_loop_res = res.data.condition_loop;

                        // let conditionArray = ['condition_time', 'condition_order', 'condition_online_pay', 'condition_recruitment'];

                        for (let i = 0; i < condition_loop_res.length; i++) {
                            if (Number(condition_loop_res[i].condition_time) > 0) {
                                // 如果在线时长返回值大于0
                                _this.checkedType.push('condition_time' + i); // 勾选在线时长
                                _this.condition_time_isShow[i] = true; // 显示在线时长输入框
                                _this.condition_loop[i].condition_time = condition_loop_res[i].condition_time; // 在线时长输入框赋值
                            }
                            if (Number(condition_loop_res[i].condition_order) > 0) {
                                // 如果有完成单数被勾选，则显示自定义配置
                                _this.diyIsShow = true;
                                _this.checkedType.push('condition_order' + i);
                                _this.condition_order_isShow[i] = true;
                                _this.condition_loop[i].condition_order = condition_loop_res[i].condition_order;
                            }
                            if (Number(condition_loop_res[i].condition_online_pay) > 0) {
                                _this.checkedType.push('condition_online_pay' + i);
                                _this.condition_online_pay_isShow[i] = true;
                                _this.condition_loop[i].condition_online_pay = condition_loop_res[i].condition_online_pay;
                            }
                            if (Number(condition_loop_res[i].condition_recruitment) > 0) {
                                _this.checkedType.push('condition_recruitment' + i);
                                _this.condition_recruitment_isShow[i] = true;
                                _this.condition_loop[i].condition_recruitment = condition_loop_res[i].condition_recruitment;
                            }

                            if (condition_loop_res[i].start_time > 0) {
                                _this.condition_loop[i].start_time = condition_loop_res[i].start_time; // 起始时间赋值
                            }
                            if (condition_loop_res[i].end_time > 0) {
                                _this.condition_loop[i].end_time = condition_loop_res[i].end_time; // 结束时间赋值
                            }

                            // for(let j = 0; j < conditionArray.length; j++){

                            //     console.log(conditionArray[j],'conditionArray[j]');
                            //     console.log(condition_loop_res[i].conditionArray[j],'condition_loop_res[i]');

                            //     if (Number(condition_loop_res[i].conditionArray[j]) > 0) {
                            //         _this.condition_loop[i].conditionArray[j] = condition_loop_res[i].conditionArray[j];
                            //         console.log(`${conditionArray[j]}_isShow[i]`,'`${conditionArray[j]}_isShow[i]`');
                            //         // _this."`${conditionArray[j]}_isShow[i]` = true;

                            //     }

                            // }
                        }
                    }
                    // 获取焦点调接口，否则不调
                    _this
                        .$post('/task/cyclical')
                        .then((res) => {
                            _this.reward_cyclical = res.data;
                        })
                        .catch((res) => {});

                    _this.submit_data.reward_cyclical = res.data.reward_cyclical; // 奖励发放周期
                    _this.submit_data.is_reviewed = res.data.is_reviewed; // 审核方式
                    if (res.data.send_cyclical) {
                        _this.submit_data.send_cyclical = res.data.send_cyclical; // 奖励有效期
                    }
                    _this.submit_data.reward_amount = res.data.reward_amount; // 现金
                    _this.submit_data.reward_monitor = res.data.reward_monitor; // 表现分
                    _this.submit_data.reward_priority = res.data.reward_priority; // 优享券
                    _this.submit_data.reward_priority_num = res.data.reward_priority_num; // 优享券数量
                    _this.submit_data.top_num = res.data.top_num; //任务次数

                    if (res.data.order_source != null) {
                        // 任务支持的订单来源
                        _this.submit_data.order_source = res.data.order_source;
                        _this.order_source = JSON.parse(res.data.order_source);
                    }
                    if (res.data.pay_channel != null) {
                        // 任务支持的支付方式
                        _this.submit_data.pay_channel = res.data.pay_channel;
                        _this.pay_channel = JSON.parse(res.data.pay_channel);
                    }
                    if (res.data.order_modes != null) {
                        // 任务支持的订单模式
                        _this.submit_data.order_modes = res.data.order_modes;
                        _this.order_modes = JSON.parse(res.data.order_modes);
                    }
                    this.$forceUpdate();
                })
                .catch((err) => {});
        },
        // 勾选完成单数后显示自定义配置，如果勾选自定义配置项里面的选项
        diyConfig() {
            if (_this.pay_channel.length > 0) {
                // 如果勾选了任务支撑的支付方式
                _this.submit_data.pay_channel = JSON.stringify(_this.pay_channel);
            } else {
                _this.submit_data.pay_channel = '';
            }
            // console.log(_this.order_source.length, "_this.order_source.length");
            if (_this.order_source.length > 0) {
                // 如果勾选了任务支持的订单来源
                // console.log(_this.order_source, "_this.order_source");
                _this.submit_data.order_source = JSON.stringify(_this.order_source);
            } else {
                // console.log(11);
                _this.submit_data.order_source = '';
            }

            if (_this.order_modes.length > 0) {
                // 如果勾选了任务支持的订单模式
                _this.submit_data.order_modes = JSON.stringify(_this.order_modes);
            } else {
                _this.submit_data.order_modes = '';
            }
        },
        // 添加按钮
        addBtn() {
            _this.condition_time_isShow.push(false);
            _this.condition_order_isShow.push(false);
            _this.condition_online_pay_isShow.push(false);
            _this.condition_recruitment_isShow.push(false);
            var condition_loop = {
                condition_time: '', // 在线时长
                condition_order: '', // 完成单数
                condition_online_pay: '', // 在线支付
                condition_recruitment: '', // 司机招募
                start_time: '', // 起始时间
                end_time: '' // 结束时间
            };

            // 每点击一次在数组中加入一个对象
            _this.condition_loop.push(condition_loop);
        },
        // 删除按钮
        delData(index) {
            // 如果只剩下一个活动配置了则不允许删除，第一个活动配置不显示删除按钮
            // 删除数组中对应index的数据
            _this.condition_loop.splice(index, 1);
            _this.condition_time_isShow.splice(index, 1);
            _this.condition_order_isShow.splice(index, 1);
            _this.condition_online_pay_isShow.splice(index, 1);
            _this.condition_recruitment_isShow.splice(index, 1);
        },
        // 优享券数量加减按钮方法
        rewardBtn(algorithm) {
            if (algorithm == '+') {
                _this.submit_data.reward_priority_num++;
            } else if (algorithm == '-') {
                if (_this.submit_data.reward_priority_num > 0) {
                    _this.submit_data.reward_priority_num--;
                } else {
                    return;
                }
            }
        },

        // 任务类型change方法
        handleRewardType(index) {
            // console.log(_this.checkedType, "el-checkbox label的值，分别是在线时长，完成单数，在线支付的label值");
            //任务类型_this.checkedType el-checkbox-group v-model="checkedType"绑定值
            if (_this.checkedType.length > 0) {
                // 如果勾选招募司机，在勾选 在线时长，完成单数，在线支付，弹出提示
                if (_this.checkedType[0] == 'condition_recruitment0') {
                    if (
                        _this.checkedType.includes('condition_time0') ||
                        _this.checkedType.includes('condition_order0') ||
                        _this.checkedType.includes('condition_online_pay0')
                    ) {
                        this.$message.error('请先取消司机招募的勾选！');
                        _this.checkedType = _this.checkedType.filter((item) => item == 'condition_recruitment' + index); // 取消在线时长，完成单数和在线支付的勾选
                    }
                }

                console.log(_this.checkedType, '_this.checkedType==');

                // 如果任务类型有勾选数据
                if (_this.checkedType.includes('condition_time' + index)) {
                    // 如果勾选在线时长
                    // _this.submit_rules.condition_time.rules.required = true; // 在线时长输入框为必填项
                    _this.condition_time_isShow[index] = true; // 在线时长后面显示input框
                } else {
                    // 取消勾选在线时长
                    // _this.submit_rules.condition_time.rules.required = false; // 在线时长输入框取消必填项

                    _this.condition_time_isShow[index] = false; // 隐藏在线时长后面显示input框

                    _this.condition_loop[index].condition_time = ''; // 清空在线时长输入框的值
                }

                if (_this.checkedType.includes('condition_online_pay' + index)) {
                    // 在线支付
                    // _this.submit_rules.condition_online_pay.rules.required = true;
                    _this.condition_online_pay_isShow[index] = true; // 在线支付后面显示input框
                } else {
                    // _this.submit_rules.condition_online_pay.rules.required = false;
                    _this.condition_online_pay_isShow[index] = false;
                    _this.condition_loop[index].condition_online_pay = '';
                }

                if (_this.checkedType.includes('condition_order' + index)) {
                    // 完成单数勾选
                    _this.condition_order_isShow[index] = true; // 后面显示input框
                    // _this.submit_rules.condition_order.rules.required = true; // 完成单数
                    _this.submit_rules.pay_channel.rules.required = true; // 任务支持的支付方式
                    _this.submit_rules.order_source.rules.required = true; // 任务支持的订单来源
                    _this.submit_rules.order_modes.rules.required = true; // 任务支持的订单模式
                } else {
                    // 取消完成单数勾选
                    _this.condition_order_isShow[index] = false; // 完成单数后的输入框不显示
                    // _this.submit_rules.condition_order.rules.required = false; // 完成单数
                    _this.submit_rules.pay_channel.rules.required = false; // 任务支持的支付方
                    _this.submit_rules.order_source.rules.required = false; // 任务支持的订单来源
                    _this.submit_rules.order_modes.rules.required = false; // 任务支持的订单模式
                    _this.condition_loop[index].condition_order = ''; // 完成单数input框
                    _this.submit_data.order_source = ''; // 任务支持的订单来源
                    _this.submit_data.pay_channel = ''; // 任务支持的支付方式
                    _this.submit_data.order_modes = ''; // 任务支持的订单模式
                    _this.order_source = [];
                    _this.pay_channel = [];
                    _this.order_modes = [];
                }

                if (_this.checkedType.includes('condition_recruitment' + index)) {
                    // 司机招募
                    // 勾选司机招募后审核方式默认手动审核，把审核方式按钮禁用，不让点自动审核选项，但是如果是其他类型，可以点手动也可以点自动
                    _this.submit_data.is_reviewed = '1'; // 审核方式默认手动审核
                    _this.is_recruitment = true; // 禁用 自动审核 和 手动审核 按钮 禁用时间段配置按钮  加号按钮不显示
                    // 勾选司机招募，则不显示添加按钮，且时间为00：00-00：00
                    _this.condition_loop[index].start_time = '00:00';
                    _this.condition_loop[index].end_time = '00:00';

                    // _this.submit_rules.condition_recruitment.rules.required = true;
                    _this.condition_recruitment_isShow[index] = true;
                    // 如果勾选司机招募，如果有勾选 在线时长 完成单数 在线支付 则取消勾选，并清空添加的数据

                    _this.condition_time_isShow[index] = false; // 在线时长后面显示input框
                    _this.condition_online_pay_isShow[index] = false; // 在线支付后面显示input框
                    _this.condition_order_isShow[index] = false; // 完成单数后的输入框不显示
                    _this.condition_loop[index].condition_time = ''; // 在线时长输入框
                    _this.condition_loop[index].condition_order = ''; // 完成单数输入框
                    _this.condition_loop[index].condition_online_pay = ''; // 在线支付输入框
                    _this.checkedType = _this.checkedType.filter((item) => item == 'condition_recruitment' + index); // 取消在线时长，完成单数和在线支付的勾选

                    // 如果点击配置的加号按钮，加了好几条数据，然后勾选其中一条数据的司机招募，则只保留当前勾选招募司机的这条配置，其他数据应删除

                    // 找到勾选了司机招募的下标，删除数组_this.condition_loop的下标中没有勾选了司机招募的那些数据
                    if (_this.condition_loop.length > 1) {
                        // _this.condition_loop = _this.condition_loop.filter((element, index1) => index1 === index);
                        // console.log(_this.condition_loop,'_this.condition_loop');
                        // console.log(_this.checkedType,'_this.checkedType');
                        _this.condition_loop = [
                            {
                                condition_time: '', // 在线时长
                                condition_order: '', // 完成单数
                                condition_online_pay: '', // 在线支付
                                condition_recruitment: '', // 司机招募
                                start_time: '00:00', // 起始时间
                                end_time: '00:00' // 结束时间
                            }
                        ];
                        _this.checkedType = ['condition_recruitment0'];
                        // 如果勾选在线时长，完成单数或者在线支付，提示用户先取消司机招募勾选
                        // console.log(_this.checkedType, '_this.checkedType');
                        // if (
                        //     _this.checkedType.includes('condition_time0') ||
                        //     _this.checkedType.includes('condition_order0') ||
                        //     _this.checkedType.includes('condition_online_pay0')
                        // ) {
                        //     this.$message.error('请先取消司机招募的勾选！');
                        //     _this.checkedType = _this.checkedType.filter((item) => item == 'condition_recruitment' + index); // 取消在线时长，完成单数和在线支付的勾选
                        // }
                    }
                } else {
                    _this.is_recruitment = false; // 自动审核 和 手动审核 按钮取消禁用
                    _this.submit_data.is_reviewed = '0';

                    // _this.submit_rules.condition_recruitment.rules.required = false;
                    _this.condition_recruitment_isShow[index] = false;
                    _this.condition_loop[index].condition_recruitment = ''; // 清空司机招募输入框的值
                }

                // _this.checkedType.forEach((item) => {
                // 不好使
                //     if (item.includes('condition_order')) {
                //         _this.diyIsShow = true; // 显示自定义配置
                //         // return;
                //         // console.log(_this.diyIsShow,'_this.diyIsShow');
                //     } else {
                //         _this.diyIsShow = false; // 不显示自定义配置
                //     }
                //      console.log(_this.diyIsShow,'_this.diyIsShow');
                // });
                for (let i = 0; i < _this.checkedType.length; i++) {
                    if (_this.checkedType[i].includes('condition_order')) {
                        _this.diyIsShow = true; // 显示自定义配置
                        break;
                    } else {
                        _this.diyIsShow = false; // 不显示自定义配置
                    }
                }

                this.$forceUpdate();
            } else {
                // 如果任务类型没有勾选数据，或者勾选后取消勾选数据 _this.checkedType.length = 0
                _this.is_recruitment = false; // 自动审核 和 手动审核 按钮取消禁用  取消时间段配置按钮的禁用
                _this.submit_data.is_reviewed = '0'; // 审核方式默认自动审核
                _this.condition_loop[index].start_time = ''; // 时间段配置默认为空
                _this.condition_loop[index].end_time = ''; // 时间段配置默认为空

                _this.condition_loop[index].condition_online_pay = ''; // 清空在线支付输入框的值
                _this.condition_loop[index].condition_order = ''; // 清空完成单数输入框的值
                _this.condition_loop[index].condition_time = ''; // 清空在线时长输入框的值
                _this.condition_loop[index].condition_recruitment = ''; // 清空司机招募输入框的值
                _this.condition_time_isShow[index] = false; // 在线时长输入框不显示
                _this.condition_order_isShow[index] = false; // 完成单数后的输入框不显示
                _this.condition_online_pay_isShow[index] = false; // 在线支付输入框不显示
                _this.condition_recruitment_isShow[index] = false; // 司机招募输入框不显示
                // _this.submit_rules.condition_time.rules.required = false; // 在线时长输入框取消必填项
                // _this.submit_rules.condition_online_pay.rules.required = false;
                // _this.submit_rules.condition_order.rules.required = false; // 完成单数为非必填项
                // _this.submit_rules.condition_recruitment.rules.required = false; // 司机招募为非必填项
                _this.submit_rules.pay_channel.rules.required = false;
                _this.submit_rules.order_source.rules.required = false;
                _this.submit_rules.order_modes.rules.required = false;

                // 取消完成单数勾选
                _this.diyIsShow = false; // 不显示自定义配置
                _this.submit_data.order_source = '';
                _this.submit_data.pay_channel = '';
                _this.submit_data.order_modes = '';
                _this.order_source = [];
                _this.pay_channel = [];
                _this.order_modes = [];

                _this.condition_loop = [
                    {
                        condition_time: '', // 在线时长
                        condition_order: '', // 完成单数
                        condition_online_pay: '', // 在线支付
                        condition_recruitment: '', // 司机招募
                        start_time: '', // 起始时间
                        end_time: '' // 结束时间
                    }
                ];
            }

            // 非响应式的属性：如果是对象属性直接赋值，Vue可能无法追踪到属性的变化，需要使用Vue.set或者this.$forceUpdate()强制更新
            this.$forceUpdate();
        },

        // 奖励类型的change方法
        handleReward() {
            // console.log(_this.checkedRewards, "el-checkbox 现金，表现分，优享券的label的值");
            //奖励类型_this.checkedType el-checkbox-group v-model="checkedType"绑定值
            if (_this.checkedRewards.length > 0) {
                // 奖励类型选择现金，表现分或者优享券
                if (_this.checkedRewards.includes('reward_amount')) {
                    // 选择现金
                    _this.submit_rules.reward_amount.rules.required = true; // 现金后输入框为必填项
                    _this.reward_amount_isShow = true; // 现金后输入框显示出来
                } else {
                    _this.submit_rules.reward_amount.rules.required = false;
                    _this.reward_amount_isShow = false;
                    _this.submit_data.reward_amount = '';
                }

                if (_this.checkedRewards.includes('reward_monitor')) {
                    // 表现分
                    _this.submit_rules.reward_monitor.rules.required = true;
                    _this.reward_monitor_isShow = true;
                } else {
                    _this.submit_rules.reward_monitor.rules.required = false;
                    _this.reward_monitor_isShow = false;
                    _this.submit_data.reward_monitor = '';
                }

                if (_this.checkedRewards.includes('reward_priority')) {
                    // 优享券
                    _this.submit_rules.reward_priority.rules.required = true;
                    _this.reward_priority_isShow = true;
                } else {
                    _this.submit_rules.reward_priority.rules.required = false;
                    _this.submit_rules.reward_priority_num.rules.required = false;
                    _this.reward_priority_isShow = false;
                    _this.submit_data.reward_priority = '';
                    _this.submit_data.reward_priority_num = '';
                }
            } else {
                // 如果没有选择任何奖励类型或者选完后取消勾选
                _this.reward_amount_isShow = false;
                _this.reward_monitor_isShow = false;
                _this.reward_priority_isShow = false;
                _this.submit_rules.reward_amount.rules.required = false;
                _this.submit_data.reward_amount = '';
                _this.submit_rules.reward_monitor.rules.required = false;
                _this.submit_data.reward_monitor = '';
                _this.submit_rules.reward_priority.rules.required = false;
                _this.submit_rules.reward_priority_num.rules.required = false;
                _this.submit_data.reward_priority = '';
                _this.submit_data.reward_priority_num = '';
            }
        },

        // cyclicalChange奖励发放周期 @visible-change方法 与super端调用不同接口
        cyclicalChange(val) {
            if (val) {
                // 获取焦点调接口，否则不调
                _this
                    .$post('/task/cyclical')
                    .then((res) => {
                        _this.reward_cyclical = res.data;
                    })
                    .catch((res) => {});
            }
        },

        // 获取优享券
        priorityLists() {
            _this.reward_priority = [];
            _this.getPriority();
        },
        getPriority() {
            _this
                .$post('/priority/priorityLists', _this.search_data_reward)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.reward_priority.push({
                            priority_mode_code: res.data[i].priority_mode_code,
                            name: res.data[i].name
                        });
                    }

                    if (_this.search_data_reward.page * _this.search_data_reward.limit < res.count) {
                        _this.search_data_reward.page += 1;
                        _this.getPriority();
                    }
                })
                .catch((err) => {});
        },

        // 搜索订单列表获取订单来源
        getPlatform() {
            _this.platform_select_array = [];
            _this
                .$post('/mine/getPlatform')
                .then((res) => {
                    _this.platform_select_array = res.data;
                })
                .catch((err) => {});
        },
        // 搜索订单支付方式
        getPayChannel() {
            _this.pay_channel_array = [];
            _this
                .$post('/mine/getPayChannel')
                .then((res) => {
                    _this.pay_channel_array = res.data;
                })
                .catch((err) => {});
        },

        //获取订单模式
        orderModeList() {
            _this.options_mode_code = [];
            _this.getMode();
        },
        getMode() {
            _this
                .$post('/order/orderModeLists', _this.mode_options_data)
                .then((res) => {
                    for (var i = 0; i < res.data.length; i++) {
                        _this.options_mode_code.push({
                            code: res.data[i].order_mode.order_mode_code,
                            name: res.data[i].order_mode.name
                        });
                    }

                    if (_this.mode_options_data.page * _this.mode_options_data.limit < res.count) {
                        _this.mode_options_data.page += 1;
                        _this.getMode();
                    } else {
                        _this.mode_options_data.page = 1;
                    }
                })
                .catch((err) => {});
        },

        // 提交
        onSubmitDig() {
            if (_this.checkedType.length == 0) {
                this.$message.error('请选择任务类型');
                return;
            }
            if (_this.submit_data.start_date > _this.submit_data.end_date) {
                this.$message.error('开始时间应该小于结束时间');
                return;
            }

            // 验证在线时长，完成单数，在线支付，司机招募的必填项
            // console.log(_this.checkedType, '_this.checkedType');
            // console.log(_this.condition_loop, '_this.condition_loop');
            // 必填项验证方法1开始  该方法是下面方法2的简化写法
            let checkedArray = [
                { val: 'condition_time', name: '在线时长' },
                { val: 'condition_order', name: '完成单数' },
                { val: 'condition_online_pay', name: '在线支付' },
                { val: 'condition_recruitment', name: '司机招募' }
            ];

            // 把勾选项放到 checkedArray数组，并循环遍历
            for (let index = 0; index < checkedArray.length; index++) {
                // 遍历在线时长，完成单数，在线支付，司机招募的checkbox v=model 绑定值
                for (let i = 0; i < _this.checkedType.length; i++) {
                    // 遍历循环配置项
                    for (let j = 0; j < _this.condition_loop.length; j++) {
                        // 勾选第几个循环项的在线时长，完成单数，在线支付，司机招募
                        if (_this.checkedType[i].includes(checkedArray[index].val + j)) {
                            // 第几个循环勾选了在线时长，完成单数，在线支付 或者 司机招募 ，且勾选的input框值为空字符串，弹出提示，提示用户填写
                            if (_this.condition_loop[j][checkedArray[index].val] == '') {
                                console.log(`请填写第${j + 1}项${checkedArray[index].name}`, 222);
                                this.$message.error(`请填写第${j + 1}项${checkedArray[index].name}`);
                                return; // 如果必填项没有填写，提示用户，并终止循环和提交数据
                            } else if (_this.condition_loop[j].start_time == '' || _this.condition_loop[j].end_time == '') {
                                this.$message.error(`请填写第${j + 1}项时间段`);
                                return; // 如果必填项没有填写，提示用户，并终止循环和提交数据
                            }
                        }
                    }
                }
            }

            // 必填项验证方法1结束

            // 必填项验证方法2开始  同样的方法需要写4遍，麻烦，所以采用方法一

            // for (let i = 0; i < _this.checkedType.length; i++) {
            //     for (let j = 0; j < _this.condition_loop.length; j++) {
            //         if (_this.checkedType[i].includes('condition_time' + j)) {
            //             if (_this.condition_loop[j].condition_time == '') {
            //                 this.$message.error(`请填写第${j}项在线时长`);
            //                 return;
            //             }
            //             if (_this.condition_loop[j].start_time == '' || _this.condition_loop[j].end_time == '') {
            //                 this.$message.error(`请填写第${j}项时间段`);
            //                 return;
            //             }
            //         }

            //         if (_this.checkedType[i].includes('condition_order' + j)) {
            //             if (_this.condition_loop[j].condition_order == '') {
            //                 console.log('完成单数输入框为空');
            //                 this.$message.error(`请填写第${j}项完成单数`);
            //                 return;
            //             }
            //             if (_this.condition_loop[j].start_time == '' || _this.condition_loop[j].end_time == '') {
            //                 this.$message.error(`请填写第${j}项时间段`);
            //                 return;
            //             }
            //         }
            //         if (_this.checkedType[i].includes('condition_online_pay' + j)) {
            //             if (_this.condition_loop[j].condition_online_pay == '') {
            //                 this.$message.error(`请填写第${j}项在线支付`);
            //                 return;
            //             }
            //             if (_this.condition_loop[j].start_time == '' || _this.condition_loop[j].end_time == '') {
            //                 this.$message.error(`请填写第${j}项时间段`);
            //                 return;
            //             }
            //         }
            //         if (_this.checkedType[i].includes('condition_recruitment' + j)) {
            //             if (_this.condition_loop[j].condition_recruitment == '') {
            //                 this.$message.error(`请填写第${j}项司机招募`);
            //                 return;
            //             }
            //             if (_this.condition_loop[j].start_time == '' || _this.condition_loop[j].end_time == '') {
            //                 this.$message.error(`请填写第${j}项时间段`);
            //                 return;
            //             }
            //         }
            //         // 如果有2个以上配置项，配置项的时间段，在线时长，完成单数，在线支付和司机招募都没进行配置，并且这些选项也没有勾选，则删除这个配置项
            //         // if (_this.condition_loop.length > 1) {
            //         //     _this.condition_loop = _this.condition_loop.filter((obj) => !Object.values(obj).every((value) => value === ''));
            //         //     console.log(_this.condition_loop, '_this.condition_loop');
            //         // }
            //     }
            // }
            // 必填项验证方法2结束

            // 如果有2个以上配置项，配置项的时间段，在线时长，完成单数，在线支付和司机招募都没进行配置，并且这些选项也没有勾选，则删除这个配置项
            if (_this.condition_loop.length > 1) {
                _this.condition_loop = _this.condition_loop.filter((obj) => !Object.values(obj).every((value) => value === ''));
                console.log(_this.condition_loop, '_this.condition_loop');
            }

            if (_this.checkedRewards.length == 0) {
                this.$message.error('请选择奖励类型');
                return;
            }

            // _this.submit_data.pay_channel = JSON.stringify(_this.pay_channel);

            // _this.submit_data.order_source = JSON.stringify(_this.order_source);
            // _this.submit_data.order_modes = JSON.stringify(_this.order_modes);
            // if (_this.start_time == '' || _this.end_time == '') {
            //     this.$message.error('开始时间和结束时间不能为空');
            //     return;
            // } else {
            //     _this.submit_data.start_time = _this.start_time;
            //     _this.submit_data.end_time = _this.end_time;
            // }
            // let timeRange = "";
            // if (_this.submit_data.start_time < _this.submit_data.end_time) {
            //   timeRange = _this.submit_data.end_time - _this.submit_data.start_time;
            // } else if (_this.submit_data.start_time > _this.submit_data.end_time) {
            //   timeRange =
            //     24 - _this.submit_data.start_time + _this.submit_data.end_time;
            // }
            // if (timeRange < _this.submit_data.condition_time) {
            //   this.$message.error("在线时长和所选择时间段不相符");
            //   return;
            // }

            // console.log(_this.submit_data, "提交数据");
            // 与super端调用不同接口
            // _this.submit_data.condition_loop = JSON.stringify(_this.condition_loop);
            _this.submit_data.condition_loop = _this.condition_loop;
            _this
                .$post('/task_new/addDriverTask', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    this.$message.success(res.msg);
                    _this.$emit('onSubmit');
                    _this.closeDialog();
                })
                .catch((err) => {});
            // 触发父组件自定义事件刷新表格
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.loading = true;
            _this.is_recruitment = false; // 自动审核 和 手动审核是否禁用
            _this.diyIsShow = false; // 勾选完成单数，显示自定义配置
            _this.reward_amount_isShow = false; // 奖励类型现金是否显示
            _this.reward_monitor_isShow = false; // 奖励类型表现分是否显示
            _this.reward_priority_isShow = false; // 奖励类型优享券是否显示
            _this.condition_time_isShow = [false]; // 在线时长后的输入框是否显示
            _this.condition_online_pay_isShow = [false]; // 在线支付后的输入框是否显示
            _this.condition_order_isShow = [false]; // 完成单数后的输入框是否显示
            _this.condition_recruitment_isShow = [false]; // 司机招募后的输入框是否显示
            _this.condition_loop = [
                {
                    condition_time: '', // 在线时长
                    condition_order: '', // 完成单数
                    condition_online_pay: '', // 在线支付
                    condition_recruitment: '', // 司机招募
                    start_time: '', // 起始时间
                    end_time: '' // 结束时间
                }
            ];
            _this.checkedRewards = []; // 奖励类型v-model绑定值
            _this.checkedType = []; // 任务类型v-model
            _this.reward_cyclical = []; // 奖励发放周期
            _this.reward_priority = []; // 优享券数组
            _this.pay_channel = []; //支付方式
            _this.order_source = []; //订单来源
            _this.order_modes = []; //订单模式
            _this.platform_select_array = []; //任务支持的订单来源
            _this.pay_channel_array = []; // 任务支持的支付方式
            _this.options_mode_code = []; // 任务支持的订单模式
            // 优享券查询条件
            _this.search_data_reward = {
                page: 1,
                limit: 10
            };
            // 表单数据
            _this.submit_data = {
                driver_type: '', // 司机类型
                task_name: '', // 任务名称
                start_date: '', // 任务开启日期
                end_date: '', // 任务结束日期
                reward_cyclical: '', // 奖励发放周期
                is_reviewed: '0', // 审核方式
                send_cyclical: '', // 奖励有效期
                reward_amount: '', // 现金
                reward_monitor: '', // 表现分
                reward_priority: '', // 优享券
                reward_priority_num: '', // 优享券数量
                top_num: '', // 任务次数
                order_source: '', // 订单来源
                pay_channel: '', // 支付方式
                order_modes: '', // 订单模式
                condition_loop: '' // 循环
            };
            _this.mode_options_data = {
                page: 1,
                limit: 10,
                status: '1'
            };

            _this.search_data = {
                page: 1,
                limit: 10
            };
            _this.submit_rules.reward_amount.rules.required = false; // 现金
            _this.submit_rules.reward_monitor.rules.required = false; // 表现分
            _this.submit_rules.reward_priority.rules.required = false; // 优享券
            _this.submit_rules.reward_priority_num.rules.required = false; // 优享券数量

            // _this.submit_rules.condition_time.rules.required = false;
            // _this.submit_rules.condition_online_pay.rules.required = false;
            // _this.submit_rules.condition_order.rules.required = false;
            // _this.submit_rules.condition_recruitment.rules.required = false; // 司机招募为非必填项
        }
    }
};
</script>

<style scoped>
.task-head {
    display: flex;
    align-items: center;
    margin-top: 30px;
}
.title-square {
    background-color: #409eff;
    display: inline-block;
    width: 4px;
    height: 30px;
    margin-right: 5px;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
    color: #606266;
}
.task-mode {
    border: 1px solid #e3e3e3;
    width: 200px;
    height: 50px;
    margin-left: 15px;
    border-radius: 8px;
    margin-bottom: 300px;
}
.desc {
    margin-left: 15px;
}
.mode-name {
    width: 33%;
    margin: 0 auto;
}
.tastCondition {
    margin-left: 1px;
}
.jt-border {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-top: 20px;
    border: 1px solid #efefef;
    margin-bottom: 10px;

    width: 90%;
}
.jd-span {
    color: #606266;
    margin-right: 460px;
}
.jia-jian-btn {
    display: inline-block;
    margin-bottom: 20px;
}
.jia-jian-btn1 {
    width: 50px;
    height: 40px;
}
.driver-naturl {
    display: flex;
    justify-content: center;
    color: #606266;
}
.jt-input {
    margin: 10px 20px;
}
.jt-input-val {
    width: 80px;
    margin-left: 10px;
}
</style>